import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../../app/store";
import {trendsCellMenu} from "./trendsTypes";

const initialState: trendsCellMenu = {
  top: 0,
  left: 0,
  newGraph: false,
  messstellen: "",
  kenngroessen: "",
};

const trendsCellMenuSlice = createSlice({
  name: "trendsCellMenu",
  initialState,
  reducers: {
    // Setters

    setTrendsCellMenuPositionTop: (state, action: PayloadAction<number>) => {
      state.top = action.payload;
    },
    setTrendsCellMenuPositionLeft: (state, action: PayloadAction<number>) => {
        state.left = action.payload;
    },
    setNewGraph: (state, action: PayloadAction<boolean>) => {
        state.newGraph = action.payload;
    },
    setTrendsCellMenuMessstellen: (state, action: PayloadAction<string>) => {
      state.messstellen = action.payload;
  },
  setTrendsCellMenuKenngroessen: (state, action: PayloadAction<string>) => {
    state.kenngroessen = action.payload;
  },
 
}
});

// Selectors
export const selectTrendsCellMenuTop = (state: RootState): number =>
state.trendsCellMenu.top;  
export const selectTrendsCellMenuLeft = (state: RootState): number =>
state.trendsCellMenu.left; 
export const selectNewGraph = (state: RootState): boolean =>
state.trendsCellMenu.newGraph;
export const selectMessstellen = (state: RootState): string =>
state.trendsCellMenu.messstellen;
export const selectKenngrossen = (state: RootState): string =>
state.trendsCellMenu.kenngroessen;


// Actions

export const { setTrendsCellMenuPositionTop, setTrendsCellMenuPositionLeft, setNewGraph, setTrendsCellMenuMessstellen, setTrendsCellMenuKenngroessen} = trendsCellMenuSlice.actions;

export default trendsCellMenuSlice.reducer;
